const token = '1O6p8M2w8OlGK2geeQcKS+PZUAuzcbsYp1TzGQJz5+Q4YZBmD6hd11FVvxo62x2nqqRdPNqMXVMDyfCSSer8X1SJcjQR9ZgQoPuvwKJNa60='

// 获取工作票数量
// http://10.2.170.75:7910/openapi/hz/work_tickets_count/V1.0?token=1O6p8M2w8OlGK2geeQcKS+PZUAuzcbsYp1TzGQJz5+Q4YZBmD6hd11FVvxo62x2nqqRdPNqMXVMDyfCSSer8X1SJcjQR9ZgQoPuvwKJNa60=
// 获取工作票每日数量统计
// http://10.2.170.75:7910/openapi/hz/work_tickets_day_count/V1.0?token=1O6p8M2w8OlGK2geeQcKS+PZUAuzcbsYp1TzGQJz5+Q4YZBmD6hd11FVvxo62x2nqqRdPNqMXVMDyfCSSer8X1SJcjQR9ZgQoPuvwKJNa60=

const riskImgMaps = {
  'ELECTRICAL_FIRST': require('../../../assets/images/workAPicture/low_risk_cyan_bg.png'),
  'ELECTRICAL_SECOND': require('../../../assets/images/workAPicture/low_risk_blue_bg.png'),
  'THERMAL_CONTROL': require('../../../assets/images/workAPicture/low_risk_green_bg.png'),
  'WIND_TURBINE': require('../../../assets/images/workAPicture/low_risk_orange_bg.png'),
  'MECHANICAL': require('../../../assets/images/workAPicture/low_risk_yellow_bg.png'),
  'DONGHUO_LEVEL_ONE': require('../../../assets/images/workAPicture/first_fire_operation.png'),
  'DONGHUO_LEVEL_TWO': require('../../../assets/images/workAPicture/second_fire_operation.png'),
  'Limited_Space_One': require('../../../assets/images/workAPicture/space.png'),
  'Limited_Space_Two': require('../../../assets/images/workAPicture/space.png'),
  'High_Altitude_Operations': require('../../../assets/images/workAPicture/high_operation.png'),
  'Hoisting_One': require('../../../assets/images/workAPicture/lifting.png'),
  'Hoisting_Two': require('../../../assets/images/workAPicture/lifting.png'),
  'Hoisting_Three': require('../../../assets/images/workAPicture/lifting.png')
}
export { token, riskImgMaps }
